export const SPEND_RANGES = ["This month", "Last 30 days", "Previous month", "All time"] as const;
export type SpendRange = (typeof SPEND_RANGES)[number];

// "All time" has no client-computable bounds — callers pass
// granularity=month with no start/end and the backend opens the window to
// the org's whole ledger. Bounds here are only for the day-grain ranges.
export function spendRangeBounds(range: Exclude<SpendRange, "All time">): { start: Date; end: Date } {
  const now = new Date();
  if (range === "This month") {
    return { start: new Date(now.getFullYear(), now.getMonth(), 1), end: now };
  }
  if (range === "Previous month") {
    return {
      start: new Date(now.getFullYear(), now.getMonth() - 1, 1),
      end: new Date(now.getFullYear(), now.getMonth(), 1),
    };
  }
  return { start: new Date(now.getTime() - 30 * 86400 * 1000), end: now };
}

export function spendDayKeys(start: Date, end: Date): string[] {
  const keys: string[] = [];
  const d = new Date(start);
  while (d < end) {
    keys.push(d.toISOString().slice(0, 10));
    d.setUTCDate(d.getUTCDate() + 1);
  }
  return keys;
}

// Fill 'YYYY-MM' keys between the first and last month present in the data,
// so all-time charts show gap months as zero bars instead of skipping them.
export function spendMonthKeys(monthsPresent: string[]): string[] {
  if (monthsPresent.length === 0) return [];
  const sorted = [...monthsPresent].sort();
  const [fy, fm] = sorted[0].split("-").map(Number);
  const [ly, lm] = sorted[sorted.length - 1].split("-").map(Number);
  const keys: string[] = [];
  let y = fy, m = fm;
  while (y < ly || (y === ly && m <= lm)) {
    keys.push(`${y}-${String(m).padStart(2, "0")}`);
    m += 1;
    if (m > 12) { m = 1; y += 1; }
  }
  return keys;
}
